// import 'bootstrap';

//import 'alert.js';
// import 'bootstrap/js/src/button.js';
//import 'carousel.js';
// import 'bootstrap/js/src/index.js';
// import 'bootstrap/js/src/collapse.js';
// import 'bootstrap/js/src/dropdown.js';
//import 'modal.js';
//import 'popover.js';
//import 'scrollspy.js';
//import 'tab.js';
//import 'toast.js';
//import 'tooltip.js';
// import 'bootstrap/js/src/util.js';




// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js